import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Base_URL } from "../url";
import "../Styling/SalaryOverview.css";
import { useAuth } from "../Context/AuthContext";
import { Wallet } from "lucide-react";

const months = [
  "Jan","Feb","Mar","Apr","May","Jun",
  "Jul","Aug","Sep","Oct","Nov","Dec"
];

const SalaryOverview = ({ filters }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // ✅ prefer filters, fallback to user
  const orgId = filters?.orgId || user?.organisationId;
  const companyCode = filters?.companyCode || user?.companyCode || "";

  const today = new Date();

  const [month, setMonth] = useState(today.getMonth() + 1);
  const [year, setYear] = useState(today.getFullYear());

  const [data, setData] = useState({
    total: 0,
    paid: 0,
    pending: 0
  });

  const [loading, setLoading] = useState(false);

  const years = Array.from({ length: 5 }, (_, i) => today.getFullYear() - i);

  /* ================= Sync Fiscal Year from Filters ================= */
  
useEffect(() => {
  if (typeof filters?.fiscalYear === "number") {
    setYear(filters.fiscalYear);
  }
}, [filters?.fiscalYear]);


  /* ================= Fetch Salary ================= */
  useEffect(() => {
    if (!orgId) return;

    const fetchSalary = async () => {
      setLoading(true);

      try {
        /* TOTAL SALARY */
        const totalParams = new URLSearchParams({
          organisationId: orgId,
          month,
          year
        });

        if (companyCode) totalParams.append("companyCode", companyCode);

        const totalRes = await fetch(
          `${Base_URL}/HrDashboard/get-total-salary?${totalParams.toString()}`
        );

        const totalJson = await totalRes.json();
        const total = totalJson?.totalSalary || 0;

        /* TOTAL PAID */
        const paidParams = new URLSearchParams({
          org_id: orgId,
          year
        });

        if (companyCode) paidParams.append("companyCode", companyCode);

        const paidRes = await fetch(
          `${Base_URL}/HrDashboard/get-year-and-month-sum/${month}?${paidParams.toString()}`
        );

        let paid = 0;
        if (paidRes.ok) {
          const paidJson = await paidRes.json();
          paid = paidJson?.[0]?.totalAmount || 0;
        }

        setData({
          total,
          paid,
          pending: Math.max(0, total - paid)
        });

      } catch (err) {
        console.error("Salary fetch error:", err);
        setData({ total: 0, paid: 0, pending: 0 });
      } finally {
        setLoading(false);
      }
    };

    fetchSalary();
  }, [orgId, companyCode, month, year]); // 🔥 fully filter-driven

  const format = n => "₹" + Number(n || 0).toLocaleString("en-IN");

return (
  <div className="salov-card">

    <div className="salov-header">
      
      <div className="salov-header-left">
        <div className="salov-icon">
          <Wallet size={18} />
        </div>
        <h6 className="salov-title">Salary Overview</h6>
      </div>

      <div className="salov-filters">
        <select
          className="salov-select"
          value={month}
          onChange={e => setMonth(+e.target.value)}
        >
          {months.map((m, i) => (
            <option key={i} value={i + 1}>{m}</option>
          ))}
        </select>

        <select
          className="salov-select"
          value={year}
          onChange={e => setYear(+e.target.value)}
        >
          {years.map(y => (
            <option key={y}>{y}</option>
          ))}
        </select>
      </div>
    </div>

    <div className="salov-body">
      <div className="salov-box salov-total">
        <span className="salov-label">Total</span>
        <strong className="salov-value">{format(data.total)}</strong>
      </div>

      <div className="salov-box salov-paid">
        <span className="salov-label">Salary Booked</span>
        <strong className="salov-value">{format(data.paid)}</strong>
      </div>

      <div className="salov-box salov-pending">
        <span className="salov-label">Pending</span>
        <strong className="salov-value">{format(data.pending)}</strong>
      </div>
    </div>

    {loading && (
      <div className="salov-loading">
        Updating salary…
      </div>
    )}
  </div>
);
};

export default SalaryOverview;
